import VQL_EXT_1 from "./VQL_EXT_1";
export default {
  VQL_EXT_1,
};
